

import './App.css';
import { createTheme, ThemeProvider } from '@mui/material';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 
import Homepage from './homepage';
import { HashRouter, Routes, Route } from 'react-router-dom';
import PageNotFound from './pageNotFound';
import NavAppBar from './navAppBar';
import { AuthProvider } from './AuthContext';
import { useRef } from 'react';

import PurpleairWebpageIncident from './purpleairWebpageIncident';
import PurpleairSensor from './purpleairSensor';
import PageLearnMore from './pageLearnMore';
import PurpleairWebpageIncidentSiteSpecific from './purpleairWebpageIncidentSiteSpecific';

function App() {

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

  // create app theme
  const theme = createTheme({
    components: {
      // Name of the component
      MuiButton: {
        styleOverrides: {
          // Name of the slot
          contained: {
            // contained button
            backgroundColor: '#2b9ed4'
            ,fontSize:  '0.7rem'
            ,padding: '4px 10px' // custom vertical and horizontal padding
            ,'&:hover': { backgroundColor: '#98d0ea'
             }
          },
          outlined: {
            color: '#2b9ed4',
            borderColor: '#2b9ed4',
            '&:hover': { backgroundColor: '#def0f8', borderColor: '#98d0ea' }
          }
        },
      },
    },
  });

  const navRef = useRef();
  const triggerNavBarFunction = (theMenu) => {
    if (navRef.current) {
      navRef.current.handleMenuItem(theMenu);
    }
  };


  return (
    <div className="App">
      <AuthProvider>
    <HashRouter future={{  v7_startTransition: true, v7_relativeSplatPath: true, }}>
      <NavAppBar ref={navRef}/>
      <div className="content">
        <ThemeProvider theme={theme}>
          <div style={{marginLeft:'5px', marginTop:'10px'}} >
      <Routes>
        <Route path="/" element={<Homepage onNewPageForMenu={triggerNavBarFunction}/>} />
        <Route path="/learnmore" element={<PageLearnMore />} />
        <Route path="/hazardhistory" element={<PurpleairWebpageIncident />} />
        <Route path="/hazardsitespecific" element={<PurpleairWebpageIncidentSiteSpecific />} />
        <Route path="/sensorpurpleair" element={<PurpleairSensor />} />
        {/* Catch-all route for 404 */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      </div>
        </ThemeProvider>
      </div>
    </HashRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
